<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>     
    <v-row v-if="loading" class="pb-3 pt-3px-3">
        <v-col class="text-center">
          <v-progress-linear
            color="info"
            height="5"
            indeterminate
            striped
          ></v-progress-linear>
        </v-col>
    </v-row>
    <v-row v-else class="pl-4 pb-2 mt-1">
      <v-col cols="12" md="6" :lg="selectedItem?3:6" transition="scale-transition">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Coupon Recensioni
            <v-spacer></v-spacer>
            <v-div class="mr-n5">
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="editItem()">
                    <v-icon color="info">mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Nuova</span>
              </v-tooltip>
              -->                  
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>                                     
            </v-div> 
          </v-card-title>
          <v-alert info class="mx-4 neu-glow">
            Per iniziare scegli un Coupon e clicca <v-icon color="info">mdi-eye</v-icon>
          </v-alert>
          <v-card-text>
            <v-data-table
              class="neu-glow"
              fixed-header
              :headers="headers"
              :items="prizes||[]"
              hide-default-footer
              :items-per-page=500
              :loading="loading||loading_refresh"
              no-data-text="Nessun dato presente in archivio"
              no-results-text="Nessun Risultato estratto"
              loading-text="Consultazione archivio: attendi..."
            >
              <template v-slot:[`item.remarks`]="{ item }">
                <v-tooltip top max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="editItem(item)" icon v-bind="attrs" v-on="on" class="float-left">
                      <v-icon color="success">mdi-message-text</v-icon>
                    </v-btn>
                  </template>
                  <span v-html="item.remarks"></span>
                </v-tooltip>                        
              </template>

              <template v-slot:[`item.active`]="{ item }">
                <v-simple-checkbox
                  v-model="item.active"
                  color="info"
                  style="pointer-events: none"
                ></v-simple-checkbox>
              </template>

              <template v-slot:[`item.highRewardRange`]="{ item }">
                <div>{{item.highRewardRange.join('-')}}</div>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="error"
                        class="mr-2"
                        @click="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>                
                  </template>
                  <span>Elimina</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="info"
                        class="mr-2"
                        @click="showItem(item)"
                      >
                        mdi-eye
                      </v-icon>                
                  </template>
                  <span>Visualizza</span>
                </v-tooltip>

              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="6" v-if="selectedItem" transition="scale-transition">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Parametri <span class="info--text ml-2">{{selectedItem.prizeName}}</span>
            <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :loading="loading_update" @click="dialog_newItem=true">
                    <v-icon color="info">mdi-creation</v-icon>
                  </v-btn>
                </template>
                <span>Crea Nuovo</span>
              </v-tooltip>  
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :disabled="JSON.stringify(selectedItem)==prize_hash" :loading="loading_update" @click="saveItem()">
                    <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva Modifiche</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>              
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow" :loading="loading_update" @click="selectedItem=null">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>               
          </v-card-title>
          <v-card-text>
           <v-row>
            <v-col cols="12" md="6" lg="3" class="">
              <div>Coupon Attivo</div>
              <div class="d-flex justify-center mt-3">
                <v-icon v-if="selectedItem.active" class="mr-3 float-left">mdi-lightbulb-on-outline</v-icon>
                <v-switch
                  color="info"
                  :label="selectedItem.active?'Attivo':'Non Attivo'"
                  dense
                  v-model="selectedItem.active"
                  inset
                  name="active"
                  hide-details
                  class="pt-0 mr-3"
                ></v-switch>
              </div>
            </v-col>
            <v-col cols="12" md="6" lg="3" class="">
              <div>Concedi Premio</div>
              <div class="d-flex justify-center mt-3">
                <v-icon v-if="selectedItem.prizeEnabled" class="mr-3  float-left">mdi-trophy-variant</v-icon>
                <v-switch
                  color="info"
                  :label="selectedItem.prizeEnabled?'Abilitato':'Non Abilitato'"
                  dense
                  v-model="selectedItem.prizeEnabled"
                  inset
                  name="prizeEnabled"
                  hide-details
                  class="pt-0 mr-3"
                ></v-switch>
              </div>
            </v-col>            
            <v-col cols="12" md="6" class="text-center">
              <div class="pa-2">
                <div class="text-left pb-2">Giorni validi</div>
                <v-btn-toggle v-model="selectedItem.validDoW" multiple small active-class="info" class="d-inline-block transparent">
                  <v-btn 
                    v-for="(d,di) in dows" :key="di" :value="d.code" :disabled="!selectedItem.prizeEnabled">
                    {{d['it'].substring(0,2).toUpperCase()}}
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div>Giorni Utilizzo Coupon</div>
              <v-slider
                class="mt-12"
                color="info"
                max=30
                min=3
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="selectedItem.duration"
                :disabled="!selectedItem.prizeEnabled"
              >        
              </v-slider>                               
            </v-col> 
            <v-col cols="12" md="6">
              <div>Minimo per Google/TA</div>
              <v-slider
                class="mt-12"
                color="info"
                max=20
                min=4
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="selectedItem.externalReviewThreshold"
                :disabled="!selectedItem.prizeEnabled"
              >        
              </v-slider>              
            </v-col>                          
            <v-col cols="12" md="6">
              <div>Intervallo Punteggio Recensione</div>
              <v-range-slider
                class="mt-12"
                color="info"
                max=20
                min=4
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="selectedItem.highRewardRange"
                :disabled="!selectedItem.prizeEnabled"
              >        
              </v-range-slider>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                class="mt-6"            
                counter
                label="Nome Premio"
                outlined
                v-model="selectedItem.highRewardName"
                hide-details
                :disabled="!selectedItem.prizeEnabled"
              >
              </v-text-field>   
            </v-col> 
            <v-col cols="12" md="6">
              <v-textarea
                class="mt-6"            
                counter
                label="Descrizione Premio"
                outlined
                v-model="selectedItem.highRewardDescription"
                hide-details
                :disabled="!selectedItem.prizeEnabled"
              >
              </v-textarea>   
            </v-col>                        
            <v-col cols="10" md="5">
              <div class="mb-5">Immagine</div>
              <v-img v-if="selectedItem.highRewardImage" 
                :src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupons/default.png'"
                :lazy-src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupons/default.png'"
                max-width="200"
                class="mx-auto"
                :style="!selectedItem.prizeEnabled?'filter: grayscale(100%)':''"

              ></v-img>              
            </v-col>
            <v-col cols="2" md="1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :id="'pick-coupon'" :disabled="!selectedItem.prizeEnabled" @click="setPictureName(i)">
                    <v-icon color="info">mdi-image-edit</v-icon>
                  </v-btn>
                </template>
                <span>Cambia Immagine</span>
              </v-tooltip>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2 mt-3" :disabled="!selectedItem.prizeEnabled" @click="dialog_imageChange_info=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Suggerimenti</span>
              </v-tooltip>
              -->              
              <avatar-cropper
                :uploadFormData="{name:settings.brand.toLowerCase().replace(/\s+/g, ''),type:'coupons',optionId:'coupon'}"
                :outputOptions="outputOptions[0]"
                :cropperOptions="cropperOptions[0]"
                @uploading="handleUploading"
                @uploaded="handleUploaded"
                @completed="handleCompleted"
                @error="handlerError"
                :trigger="'#pick-coupon'"
                :upload-url="uploadURL" 
              />                           
            </v-col>                                                                                                         
           </v-row>
          </v-card-text>
        </v-card>          
      </v-col>      
      <v-col cols="12" md="6" lg="3" class="pr-6" v-if="selectedItem" transition="scale-transition">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Cosa vede il Cliente
            <v-spacer></v-spacer>
            <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click="selectedItem=null">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>
              -->               
          </v-card-title>
          <v-card-text class="text-caption">(ipotizzando un punteggio di 4 stelle per ogni voce)</v-card-text>
          <v-card-text>
            <v-card class="pa-4  neu-glow">
              <div>
                {{$t('Review.Thanks for your time')}},
                <p>{{$t('Review.Your opinion is very important to us since it help us every day to improve')}}</p>
                <p v-if="!selectedItem.prizeEnabled" class="text-center pt-5"><v-icon color="red" style="font-size:140px">mdi-heart</v-icon></p>
                <template v-else> 
                  <div>{{$t('Review.We are happy to inform that we have reserved you a free coupon to be used within')}}
                    <div class="font-weight-bold text-center">
                      {{' ' + addDaysFormatted(selectedItem.duration)}}
                    </div>
                    <span v-if="selectedItem.validDoW"> {{$t('Review.on')}} {{dows.filter(d=>selectedItem.validDoW.includes(d.code)).map(r=>r[settings.locale]).join(', ')}} </span>
                    {{$t('Review.for')}}
                  </div>
                  <p class="text-center font-weight-bold">{{selectedItem.highRewardName}}</p>
                  <v-img v-if="selectedItem.highRewardImage" 
                    :src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupon/default.png'"
                    :lazy-src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupon/default.png'"
                    max-width="200"
                    class="mx-auto"
                  ></v-img>
                  <p v-if="selectedItem.highRewardDescription" class="mt-2">{{selectedItem.highRewardDescription}}</p>
                  <p class="mt-2">{{$t('Review.At your arrival, remember to show the QRCode to the waiter')}}</p>
                  <div class="text-center">
                    <qrcode-vue :value="QRCodeLink" :size="150" level="L"></qrcode-vue>
                  </div>
                  <p class="text-center mt-2">{{$t('Review.For your convenience, we just sent you a WhatsApp message with the QR Code')}}</p>
                </template>
              </div>
            </v-card>            
          </v-card-text>
          <v-card-text v-if="sumReviews>=selectedItem.externalReviewThreshold">
            <v-card class="pa-4  neu-glow">
              <div>
                {{$t('Review.Thanks for your time')}}, 
                <p>{{$t('Review.Share your review loading it on Tripadvisor and or Google')}}:</p>
                <p>{{$t('Review.Your review has already been copied into the clipboard: you have just to paste it')}}</p>
                <p>{{$t('Review.To proceed, click the button')}}.</p>
              </div>
              <v-btn color="#00aa6c" block >
                Tripadvisor
              </v-btn>
              <v-btn class="mt-2" color="info" block >
                Google
              </v-btn> 
            </v-card>
          </v-card-text>
        </v-card>          
      </v-col>
    </v-row>
    <!--
    <v-dialog v-model="dialog_imageChange_info" max-width="400">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Suggerimenti
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_imageChange_info = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1">
                <v-col md="12" cols="12">
                    <p>
                        Si consiglia di ritagliare una immagine quadrata, possibilmente senza sfondo
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    -->
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card class="neu-glow pa-4">
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-card class="neu-glow pa-4">
              <v-row class="mx-5 mt-1">            
                <v-col md="3" cols="6">
                  Coupon Attivo
                </v-col>
                <v-col md="9" cols="6">
                  Se il coupon è attivo ed il punteggio di feedback è compreso nel suo range, è il coupon che verrà mostrato al cliente, se non è attivopuò essere sceltoAbilita o disabilita il premio indipendentemente dai parametri successivi
                </v-col>
                <v-col md="3" cols="6">
                  Abilita Premio
                </v-col>
                <v-col md="9" cols="6">
                  Abilita o disabilita il premio indipendentemente dai parametri successivi
                </v-col>
                <v-col md="3" cols="6">
                  Giorni Validi
                </v-col>
                <v-col md="9" cols="6">
                  Giorni della settimana validi per spendere il premio.
                  <br>Cambiate il valore e verificate cosa cambia in "Cosa vede il Cliente"
                </v-col>
                <v-col md="3" cols="6">
                  Durata
                </v-col>
                <v-col md="9" cols="6">
                  Giorni entro i quali il premio può essere riscosso
                  <br>Cambiate il valore e verificate cosa cambia in "Cosa vede il Cliente"
                </v-col>
                <v-col md="3" cols="6">
                  Minimo per Google/TA
                </v-col>
                <v-col md="9" cols="6">
                  Somma minima delle stelle ottenute nella valutazione interna (escluso Location) per richiedere la recensione su Google o TripAdvisor
                </v-col>
                <v-col md="3" cols="6">
                  Intervallo Premio
                </v-col>
                <v-col md="9" cols="6">
                  Intervallo della somma di stelle ottenute nella valutazione interna (escluso Location) per offrire il Coupon
                </v-col>
              <v-col md="3" cols="6">
                  Nome Premio
                </v-col>
                <v-col md="9" cols="6">
                  Nome del premio che verrà visualizzato dal Cliente
                  <br><span class="red--text">Specificare la quantità: esempio 1 Bottiglia, oppure 1 Calice <strong>ciascuno</strong></span>
                </v-col>
                <v-col md="3" cols="6">
                  Descrizione del Premio
                </v-col>
                <v-col md="9" cols="6">
                  Descrizione Libera del premio (facoltativa)
                </v-col> 
                <v-col md="3" cols="6">
                  Immagine Premio
                </v-col>
                <v-col md="9" cols="6">
                  Immagine coordinata del premio: si consiglia di ritagliare una immagine quadrata, la dimensione viene automaticamente ridotta a 600x600px
                </v-col>                            
            </v-row>
          </v-card>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete" max-width="400px">
        <v-card>
            <v-card-title class="text-h6">
              Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  @click="saveItem('delete')">
                      <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                  </template>
                  <span>Si, Confermo</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>No, Esci</span>
              </v-tooltip>              
            </v-card-title>
            <v-divider></v-divider>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_newItem" max-width="600px" v-if="selectedItem">
        <v-card class="neu-glow">
            <v-card-title class="text-h6">
              Nuovo Coupon
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :disabled="!selectedItem.newPrizeName" :loading="loading_update"  @click="saveItem('new')">
                      <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                  </template>
                  <span>Salva</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_newItem=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Annulla</span>
              </v-tooltip>              
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-3">
              <div>Inserisci nome Nuovo Coupon</div>
              <v-text-field
                class="mt-6"            
                counter
                label="Nome Coupon"
                outlined
                v-model="selectedItem.newPrizeName"
                hide-details
              >
              </v-text-field>   
            </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
import AvatarCropper from "../AvatarCropper";
import QrcodeVue from 'qrcode.vue'
export default {
   components: {
      QrcodeVue,
      AvatarCropper
    },  
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      dialog_edit:false,
      dialog_delete:false,
      dialog_imageChange_info:false,
      dialog_newItem:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      snackbar:null,
      snackbar_color:null,
      snackbar_message:null,
      allLocations:null,
      clockStep:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      mealId:null,
      tabId:null,
      dowId:null,
      slotId:null,
      QRCodeLink:'BB560C31F20E418C0A5E2955ECD88FEFED082D42',
      review:{"food":4,"service":4,"value":4,"location":4,"review":null},
      editedItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      emptyItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],
      headersPromo:[
              {title:"Omaggio",remarks:"Omaggio (per persona) offerto"},
              ],
      headers: [
                { text: 'Nome',         value: 'prizeName',   align: 'start',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'Attivo',       value: 'active',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                //{ text: 'Coupon',       value: 'prizeEnabled',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Range',   value: 'highRewardRange',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Azione',       value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],              
      allMeals:null,
      selectedItem:null,
      sumReviews:null,
      uploadURL:'https://ibookrestaurant.com/ajax/settings/upload.php',
      cropperOptions:[
                      {dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true},
                      {aspectRatio: 4, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true}
                     ],
      outputOptions: [
                        {
                        width: 600,
                        height: 600,
                        minWidth: 300,
                        minHeight: 300,
                        maxWidth: 900,
                        maxHeight: 900,
                        imageSmoothingEnabled: true,
                        imageSmoothingQuality: 'high',
                      }
                    ],      
      pictureName:null,
      pictureNameW:null,
      pictureNameRoot:null,
      pictureNameRootW:null,
      prize_hash:null, 
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      //alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    /*
    'selectedItem.highRewardRange':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'selectedItem.lowRewardRange':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.food':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.service':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.value':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },    
    item (newValue) {
      console.log(289,newValue)
      //this.getData(newValue)
    }*/
  },
  methods:
  {
    handleUploading({ form, request }) {
      // show a loader
      console.log(384, {form, request})
    },
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificata Immagine';
        this.selectedItem.reviewImage=response.pictureName;
        this.selectedItem.highRewardImage=response.pictureName;
        console.log(654,this.selectedItem.reviewImage)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, message, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },    
    setPictureName(i)
    {
      console.log(648,i);
      //this.pictureType=i.optionId.includes('TB')?'tb':'db';
      this.pictureNameRoot='';
      this.optionId='';
      this.pictureName='';
    },
   addDaysFormatted(days) {
     var result = new Date();
     result.setDate(result.getDate() + days);
     return result.toLocaleDateString( this.settings.locale,{ weekday: 'long',  month: 'long', day: 'numeric' });
   },/*
   calcPrize()
   {
      const review2={...this.review};
      delete review2.location;
      const sumReviews = Object.values(review2).reduce((a, b) => a + b, 0);
      this.sumReviews=sumReviews;
      const hrr=this.selectedItem.highRewardRange;
      const lrr=this.selectedItem.lowRewardRange;
      console.log(653,hrr,lrr,sumReviews)
      if(sumReviews>=hrr[0]&&sumReviews<=hrr[1])
      {
        console.log(656)
        this.selectedItem.hasPrize=true
        this.selectedItem.reviewPrize=this.selectedItem.highRewardName;
        this.selectedItem.reviewDescription=this.selectedItem.highRewardDescription;
        this.selectedItem.reviewImage=this.selectedItem.highRewardImage;
      }
      else if (sumReviews>=lrr[0]&&sumReviews<=lrr[1])
      {
        console.log(663)
        this.selectedItem.hasPrize=true
        this.selectedItem.reviewPrize=this.selectedItem.lowRewardName;
        this.selectedItem.reviewDescription=this.selectedItem.lowRewardDescription;
        this.selectedItem.reviewImage=this.selectedItem.lowRewardImage;
      }
      else
      {
        console.log(670)
        this.selectedItem.hasPrize=false
        this.selectedItem.reviewPrize=null;
        this.selectedItem.reviewDescription=null;
        this.selectedItem.reviewImage=null;
      }
   },*/
   save: _.debounce(function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(296,event);
      console.log(297,event.target.name,event.target.value,event.target.id)
      console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      console.log(704,this.dow,this.dows)
      //var dow=this.dows.findIndex(d=>d==this.dow.codeId)+1
      var pload={"parameter":event.target.name,"value":value,"slotId":event.target.id,"dow":dow};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(307,payload)
      this.updateDB(payload)
    }, 1000), 
    showItem(i)
    {
      console.log(702,i)
      this.selectedItem=i;
      this.prize_hash=JSON.stringify(this.selectedItem);
    },  
    editItem(f=null)
    {
      if (f) 
      {
        this.editedItem=f;
      }
      else{
        this.editedItem={...this.emptyItem};
        this.editedItem.active=1;
      }
      console.log(214,f)
      this.hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.selectedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveItem(a)
    {
        console.log(144,this.selectedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        switch(a)
        {
          case 'delete':
            action='deleteItem'
            this.selectedItem.erase=1;
          break;
          case 'new':
            action='saveItem';
            this.selectedItem.prizeId=null;
            this.selectedItem.erase=0;
          break;
          default:
            action='saveItem';
            this.selectedItem.erase=0;
        }

        let payload={"action":action,"table":"User_Prizes","payload":JSON.stringify(this.selectedItem)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            //this.snackbar_color="success"
            //this.message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.getData();
            //this.$root.$emit('onupdateLocations', null);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        //this.editedItem={...this.emptyItem}
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"action":"Prizes_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.prizes=res.data.payloads.allPrizes;

                    console.log(315,this.prizes)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },    
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(383,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;
            
            if (res.data.message)
            {
                console.log(392);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(401);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>